import { campaignUrl } from "@/modules/oabalytics/helper"

export default (_, inject) => {
    inject("oabalytics", {
        campaignUrl,
    })
}
